(function($) {
    'use strict';

    var SampleBox = function(el) {
        this.$el = $(el);
        this.$selector = this.$el.find('.item-select');
        this.$selected = this.$el.find('.item-selected-sizes');
        this.$sizes = this.$el.find('.sizes');
        this.$size = this.$sizes.find('input');

        this.init();
    };

    SampleBox.prototype = {
        type: null,
        selected: [],

        init: function() {
            var that = this;

            if (that.$sizes.hasClass('sizes-checkbox')) {
                that.type = 'checkbox';
                that.$size = that.$sizes.find('input');
            } else if (that.$sizes.hasClass('sizes-select')) {
                that.type = 'select';
                that.$size = that.$sizes.find('select');
                that.$sizes.find('select').selectOrDie();
            }

            if (that.getSelected().length > 0) {
                that.updateSelected();
            }

            that.bindEvents();
        },

        bindEvents: function() {
            var that = this;

            that.$size.on('change', function() {
                that.updateSelected();
            });
        },

        getSelected: function() {
            var that = this,
                $size,
                selected = [];

            that.$size.each(function() {
                $size = $(this);
                if ($size.is(':checked')) {
                    selected.push($size.val());
                }
            });

            return selected;
        },

        updateSelected: function() {
            var that = this,
                selected = that.getSelected();

            that.$selected.empty();

            $.each(selected, function(index, value) {
                if (index > 0) {
                    value = ', ' + value;
                }
                that.$selected.append(value);
            });
        }
    };

    $.fn.sampleBox = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('sampleBox');

            if (!data) {
                $this.data('sampleBox', (data = new SampleBox(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };

    $.fn.sampleBox.Constructor = SampleBox;
})(jQuery);
